export type BrandVariant = "light" | "dark";

export interface BrandPalette {
  primary: string;
  secondary: string;
  text: string;
}

const BRAND_PALETTES: Record<BrandVariant, BrandPalette> = {
  light: {
    primary: "#60a5fa",
    secondary: "#a78bfa",
    text: "#f8fafc",
  },
  dark: {
    primary: "#3b82f6",
    secondary: "#8b5cf6",
    text: "#0f172a",
  },
};

export const getBrandPalette = (variant: BrandVariant): BrandPalette => {
  return BRAND_PALETTES[variant];
};
